import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import Message from '~/Components/Message/Message';
import ProfileHeader from '~/Components/ProfileHeader/ProfileHeader';

import styles from './Hidden.scss';

const Hidden = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <ProfileHeader noSearch />
        <Message text={t('Пользователь скрыл свой профиль.')} />
      </div>
    </div>
  );
};

export default memo(Hidden);
